/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SwapStatus {
    PENDING = 'pending',
    SUCCESS = 'success',
    ERROR = 'error',
}
